import { Link } from 'react-router-dom';
import logo from '../../assets/imgs/aci6-header.webp';
import logoSm from '../../assets/imgs/aci6-header-192.webp';
import '../../styles/header.scss';
import Dropdown from '../Dropdown';
import { MENU } from '../../configs/header';
import { Menu } from 'lucide-react';

const TEXT_SRC = `${process.env.PUBLIC_URL || ''}/logo-header-text.webp`;
const TEXT_SRC_SM = `${process.env.PUBLIC_URL || ''}/logo-header-text-800.webp`;

const HeaderHome = ({toggleSidebar, isSidebarOpen}: {toggleSidebar: () => void, isSidebarOpen: boolean}) => {
  return <header className='absolute top-0 left-0 w-full'>
    <div className='flex justify-between items-start lg:justify-center pt-4 lg:pt-12 px-2 lg:px-0'>
      <div className='flex items-center lg:-ml-24'>
        <Link to="/">
          <img
            src={logo}
            srcSet={`${logoSm} 192w, ${logo} 512w`}
            sizes="(min-width: 1024px) 12rem, 20vw"
            className='w-screen-1/5 lg:w-48 h-screen-w-1/5 lg:h-48 min-vw-100 min-w-[80px] min-h-[80px] lg:p-8'
            alt='ASA 2 logo'
            width={512}
            height={512}
            loading="eager"
            decoding="async"
          />
        </Link>
        <div className='hidden lg:block'>
          <ul className='menu flex justify-center gap-8 text-white'>
            {MENU.map(item => {
              if (!item.items.length || item.hideItemsOnHeader) return <li key={item.text.replace(' ', '')}><Link to={item.link}>{item.text}</Link></li>;
              return <li key={item.text.replace(' ', '')}><Dropdown text={item.text} link={item.link} items={item.items} /></li>;
            })}
          </ul>
        </div>
      </div>
      <button
          type="button"
          onClick={toggleSidebar}
          className="lg:hidden pr-6 pt-8"
          aria-haspopup="dialog"
          aria-expanded={isSidebarOpen}
          aria-controls="sidebar"
          aria-label="Apri menu"
        >
          <Menu color='white' aria-hidden="true" focusable="false" />
          <span className="sr-only">Apri menu</span>
        </button>
    </div>
    <img
      src={TEXT_SRC}
      srcSet={`${TEXT_SRC_SM} 800w, ${TEXT_SRC} 1200w`}
      sizes="(min-width: 1024px) 60vw, 100vw"
      className='w-screen min-w-[260px] lg:w-[60%] mx-auto'
      alt='Acireale 6'
      width={1200}
      height={300}
      loading="eager"
      decoding="async"
      fetchPriority="high"
    />
    <h1 className='text-4xl text-center font-poppins px-5 text-white'>"Insieme dal <b>2000</b>, per una comunità più unita"</h1>
  </header>
}

export default HeaderHome;
